import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'sc-accordion',
  template: `
    <h2 class="accordion-head" (click)="onClick($event)"><span class="questionId">{{questionId}}. </span>{{ title }}</h2>
    <div class="accordion-body" [class.active]="active">
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent {

  @Input() title: string;

  @Input() questionId: string;

  @Input() active: boolean = false;

  @Output() toggleAccordion: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  onClick(event) {
    event.preventDefault();
    this.toggleAccordion.emit(this.active);
  }

}